import { render, staticRenderFns } from "./WebsiteContentSettings.vue?vue&type=template&id=267d2560&"
import script from "./WebsiteContentSettings.vue?vue&type=script&lang=js&"
export * from "./WebsiteContentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports